<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<div class="div-container">
  <h1 class="bl-generate-analysis__title"><b> {{titleActionPlan}}</b></h1>
  <br />
  <br />
    <div>
      <div class="col-md-4 col-sm-4 bl-afs-review__group-data-wrapper">
        <div class="bl-select without-br">
          <span class="labe-bold">Operation number: </span>
          <mat-form-field appearance="standard" style="width: 90%;">
            <input
              type="text"
              class="form-control"
              matInput
              placeholder="Search"
              aria-label="Search"
              [matAutocomplete]="auto"
              [formControl]="OperationsCtrl"            
              required
            />
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option
                *ngFor="let Operation of filteredOperations | async"
                [value]="Operation.label"
                (onSelectionChange)="changeOperation(Operation)">
                <span>{{ Operation.label }}</span>
              </mat-option>
            </mat-autocomplete>
            <span class="bl-historical-search__margin-icon-search" style=" margin-left: -20px;">
              <i class="fas fa-search"></i>
            </span>            
        </mat-form-field>
        </div>
      </div><br>
      <div *ngIf="!isMyactionPlan" class="col-md-3 col-sm-3 bl-afs-review__group-data-wrapper">
        <span>Loan number: </span>
          <span class="bl-afs-review__group-data--strong-letter"
            >{{loanNumber}}</span
          >
      </div>
      <div *ngIf="!isMyactionPlan" class="col-md-5 col-sm-5 bl-afs-review__group-data-wrapper without-br">
          <span>Project name: </span>
          <span class="bl-afs-review__group-data--strong-letter">{{projectName}}</span>
      </div><br>
      <div *ngIf="false" class="col-md-5 col-sm-5 bl-afs-review__group-data-wrapper without-br">
       <span class="status-action-plan" 
       [ngClass]="
                {
                  'skin-reject1' : status == 'Requerido',
                  'skin-reject2' : status == 'Remitido',
                  'skin-reject3' : status == 'En Proceso',
                  'skin-reject4' : status == 'Incumplido'
                }" >Status: {{status}} </span>
      </div>
    </div>
  <div>
    <bid-action-plan-table
      [headerTable]="headerTUAP"
      [operationNumber] = "getOperation"
      (actionPlans) = "getActionPlans($event)"
    >
    </bid-action-plan-table>
  </div>
</div>
